import React from "react";

import { css } from "@emotion/core";

import { Colors } from "@zapier/design-system";

import { Currency, Price } from "@zapier/currency";

import { tableItem } from "../CheckoutSummary";

type AmountDueProps = {
  amountDue: number;
  currency?: Currency;
};

const invoiceTotalCss = css`
  display: flex;
  font-weight: 600;
  padding: 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${Colors.neutral400};
  }
`;

const invoiceTotalPriceCss = css`
  font-size: 1em;
  white-space: inherit;
  padding-left: 20px;
`;

export const AmountDue = ({ amountDue, currency }: AmountDueProps) => {
  // for the Backend, a negative price means a refund...
  const isRefund = amountDue < 0;

  return (
    <div css={[invoiceTotalCss, tableItem]}>
      <span>
        {isRefund
          ? "Credit applied to your next invoice"
          : "Amount charged today"}
      </span>
      <span css={invoiceTotalPriceCss}>
        <Price currency={currency} isLocalized={true}>
          {Math.abs(amountDue)}
        </Price>
      </span>
    </div>
  );
};
